import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoFuentesFinanciamientoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoFuentesFinanciamientoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoFuentesFinanciamientoService(): Observable<BodyListResponse<CatalogoFuentesFinanciamientoDTO>> {
    return this.http.get<BodyListResponse<CatalogoFuentesFinanciamientoDTO>>(API_URL + '/api/v1/catalogoFuentesFinanciamiento/todos');
  }

  guardarCatalogoFuentesFinanciamientoService(catalogoFuentesFinanciamientoDTO: CatalogoFuentesFinanciamientoDTO): Observable<BodyResponse<CatalogoFuentesFinanciamientoDTO>> {
    return this.http.post<BodyResponse<CatalogoFuentesFinanciamientoDTO>>(API_URL + '/api/v1/catalogoFuentesFinanciamiento', catalogoFuentesFinanciamientoDTO);
  }

  getCatalogoFuentesFinanciamientoPorCodigoCatalogoFuentesFinanciamientoService(codigoCatalogoFuentesFinanciamiento: string): Observable<BodyResponse<CatalogoFuentesFinanciamientoDTO>> {
    return this.http.get<BodyResponse<CatalogoFuentesFinanciamientoDTO>>(API_URL + '/api/v1/catalogoFuentesFinanciamiento/' + codigoCatalogoFuentesFinanciamiento);
  }
}
